"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalContentCardPropTypes = exports.CardHeaderPropTypes = exports.CardBodyPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme/lib/AirasiaClassic/theme"));
var _constant2 = require("./constant");
var VerticalContentCardPropTypes = {
  PropTypes: {
    data: _propTypes.default.shape({
      displayDirection: _propTypes.default.string,
      tags: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
      tagColor: _propTypes.default.string,
      image: _propTypes.default.string,
      title: _propTypes.default.string,
      subtitle: _propTypes.default.string,
      tagline: _propTypes.default.string,
      findTitle: _propTypes.default.string,
      price: _propTypes.default.string,
      abovePriceText: _propTypes.default.string,
      belowPriceText: _propTypes.default.string,
      comingSoonLabel: _propTypes.default.string
    }),
    gaID: _propTypes.default.string,
    index: _propTypes.default.string,
    fireGtm: _propTypes.default.func,
    gtmEventData: _propTypes.default.string,
    theme: _propTypes.default.string,
    columnSpan: _propTypes.default.oneOf(_constant2.ARR_COLUMN_SPAN),
    customProperties: _propTypes.default.object,
    cardContainerBackgroundColor: _propTypes.default.string,
    cardContainerMargin: _propTypes.default.string,
    cardContainerPadding: _propTypes.default.string,
    cardBorderRadius: _propTypes.default.string,
    cardBoxShadow: _propTypes.default.string,
    contentPadding: _propTypes.default.string,
    cardBodyMargin: _propTypes.default.string,
    cardBodyWidth: _propTypes.default.string,
    cardFooterAlignment: _propTypes.default.string,
    cardFooterActionIcon: _propTypes.default.string,
    cardFooterActionIconBackgroundColor: _propTypes.default.string,
    cardFooterActionIconBorderRadius: _propTypes.default.string,
    cardFooterActionIconPadding: _propTypes.default.string,
    titleFontColor: _propTypes.default.string,
    titleFontWeight: _propTypes.default.string,
    subtitleFontSize: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    cardContainerBackgroundColor: _theme.default.colors.default,
    cardContainerMargin: _theme.default.space.tiny,
    cardContainerPadding: '0',
    cardBorderRadius: '25px',
    cardBoxShadow: '0px 0px 7px rgba(0, 0, 0, 0.1)',
    contentPadding: '13px',
    cardBodyMargin: '0',
    cardBodyWidth: '100%',
    cardFooterAlignment: 'left',
    cardFooterActionIconBorderRadius: _theme.default.borderRadius.large,
    cardFooterActionIconPadding: _theme.default.space.mini,
    withPadding: true
  }
};
exports.VerticalContentCardPropTypes = VerticalContentCardPropTypes;
var CardHeaderPropTypes = {
  PropTypes: {
    imageUrl: _propTypes.default.string
  },
  DefaultProps: {
    imageHoverAnimation: true
  }
};
exports.CardHeaderPropTypes = CardHeaderPropTypes;
var CardBodyPropTypes = {
  PropTypes: {
    tags: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
    tagColor: _propTypes.default.string,
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    findTitle: _propTypes.default.string,
    gaID: _propTypes.default.string
  }
};
exports.CardBodyPropTypes = CardBodyPropTypes;